const currentPage = (state) => state.currentPage;
const nextButtonDisabled = (state) => state.nextButtonDisabled;

export default {
  currentPage,
  nextButtonDisabled,
};
